<template>
    <div class="main">
        <div class="p-absolute" style="overflow: hidden; width: 100%">
            <div class="video-wrapper full-screen" style="overflow: hidden" data-aos="fade-in" data-aos-delay="50">
                <div class="mask p-absolute black"/>
                <video width="100%" playsinline autoplay loop muted>
                    <source src="../assets/videos/retro.mp4" type="video/mp4">
                </video>
            </div>
            <div class="full-screen" style="background: black" />
            <div class="video-wrapper full-screen video-details d-none d-md-block" style="overflow: hidden; position: relative" data-aos="fade-in" data-aos-delay="300">
                <div class="mask p-absolute black"/>
                <video width="100%" playsinline autoplay loop muted>
                    <source src="../assets/videos/jelly.mp4" type="video/mp4">
                </video>
            </div>
        </div>
        <div>
            <v-container class="header d-none d-md-block" data-aos="fade-up" data-aos-delay="50">
                <v-row>
                    <v-col class="col-12 col-sm-6 text-center text-sm-left"><h5>NICKY</h5></v-col>
                    <v-col class="col-12 col-sm-6 text-center text-sm-right">
                        <a class="link" @click="scrollTo('home')">Home</a>
                        <a class="ml-6 link" @click="scrollTo('about')">About</a>
                        <a class="ml-6 link" @click="scrollTo('works')">Works</a>
                    </v-col>
                </v-row> 
            </v-container>
            <div ref="home" style="position: relative; overflow: hidden; z-index: 30" data-aos="fade-up" data-aos-delay="50">
                <v-container class="d-flex flex-column full-screen">
                    <v-row>
                        <v-col class="col-md-12 col-12 text-center align-self-center">
                            <div>
                                <p class="text-center">Hi, I’m</p>
                                <h1 class="text-center">Nicky, Lim Yean Fen</h1>
                                <br>
                                <p class="text-center grey-text-500">A Senior UI UX Designer who design with purpose, driven by structure.</p>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <v-container ref="about" class="d-flex flex-column full-screen" style="z-index: 30" data-aos="fade-up" data-aos-delay="50">
                <v-row>
                    <v-col class="col-md-5 align-self-center pr-md-8">
                        <img class="avatar-card" src="../assets/images/avatar2023.png" width="100%"/>
                    </v-col>
                    <v-col class="col-md-7 col-12 text-center text-sm-left align-self-center pl-md-8">
                        <div>
                            <p class="pb-2 small-uppercase accent-color">WHO AM I</p>
                            <h2>A creative problem solver and continuous learner</h2>
                            <br>
                            <p class="grey-text-600">I believe that a well-organized design system and collaboration with dev and business team are the keys to success in product design.</p>
                            <br><br>
                            <div class="d-flex flex-column flex-sm-row pb-4 body grey-text-400">
                                <span class="pr-4 pb-sm-0 pb-1">2022 - Present</span>
                                <span>Snr. Product Designer, Astro</span>
                            </div>
                            <div class="d-flex flex-column flex-sm-row pb-4 grey-text-600 body">
                                <span class="pr-4 pb-sm-0 pb-1">2021 - 2022</span>
                                <span>UX Designer, Affin Hwang Investment Bank</span>
                            </div>
                            <div class="d-flex flex-column flex-sm-row pb-4 grey-text-600 body">
                                <span class="pr-4 pb-sm-0 pb-1">2020 - 2021</span>
                                <span>UI Designer, Izyoo</span>
                            </div>
                            <div class="d-flex flex-column flex-sm-row pb-4 grey-text-600 body">
                                <span class="pr-4 pb-sm-0 pb-1">2017 - 2020</span>
                                <span>Visual Developer, Fusionex</span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <div ref="works" data-aos="fade-up" data-aos-delay="50">
                <div ref="workList">
                    <v-container class="d-flex flex-column">
                        <v-row>
                            <v-col class="col-md-7 col-12 text-center text-md-left pt-16 mt-16">
                                <div>
                                    <p class="pb-2 small-uppercase accent-color">WHAT I DO</p>
                                    <h2>Crafted with dedicated and love</h2>
                                    <br>
                                    <p class="grey-text-600">I love what I do and combine my knowledge of front-end development and design to go above and beyond for my clients.<br><br>Check out some of my recent best works:</p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="col-12 col-md-6" v-for="(work,index) in works" :key="index">
                                <kinesis-container>
                                    <kinesis-element :strength="6" type="depth" class="card shodow-none pa-0">
                                        <v-card>
                                            <kinesis-element :strength="16" type="depth">
                                                <v-img :src="require('../assets/images/recent-works/'+work.cardCoverImg)" class="ma-md-6 ma-4 rounded"/>
                                            </kinesis-element>
                                            <div>
                                                <v-card-subtitle class="pb-0 pt-6 px-md-6 px-4 small-uppercase">
                                                {{work.year}}
                                                </v-card-subtitle>
                                                <v-card-title class="pt-1 px-md-6 px-4 pb-4">
                                                    <h3>{{work.title}}</h3>
                                                </v-card-title>
                                                <v-card-text class="px-md-6 px-4 pb-8">
                                                    <span v-for="(platform, index) in work.platforms" :key="index" class="pr-2">{{platform}}</span>. 
                                                    <span v-for="(tag, index) in work.tags" :key="index" class="pr-2">{{tag}}</span>
                                                    <div v-if="work.processComponent" class="text-right">
                                                        <br><br>
                                                        <router-link :to="{name: 'WorkDetails', params: {id: work.id}}" 
                                                                    :disabled="work.processComponent"
                                                                    :event="work.processComponent ? 'click':''" class="link accent-color">
                                                                    View Project ↘
                                                        </router-link>
                                                    </div>
                                                    <div v-else class="text-right grey-text-700 link">
                                                        <br><br>
                                                        Coming Soon
                                                    </div>
                                                </v-card-text>
                                            </div>
                                        </v-card>
                                    </kinesis-element>
                                </kinesis-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data(){
        return{
            works: [],
        }
    },
    async created() {
        await this.loadWorks();
    },
    methods: {
        async loadWorks() {
            this.works = await this.$workRepository.getAll();
        },
        scrollTo(refName) {
            var element = this.$refs[refName];
            var top = element.offsetTop;
            var behavior = "smooth";
            
            this.$refs.workList.scrollTop = 0;
            window.scrollTo(0, top, behavior);
        },
    }
}
</script>

<style lang="scss" scoped>

    @import '../App.scss';

    .mask {
        height: 100vh;
        width: 100vw;
        &.black {
            background: linear-gradient(to bottom, rgba(0,0,0,0%) , rgba(0,0,0,100%) ) !important;
        }
    }

    .v-card {
        color: $grey-color-100 !important;
        border: 1px solid $grey-color-800;
        background: hsla(210, 11%, 15%,.3);
        border-radius: 22px;
        
        &:hover {
            transition: scale(1.2);
        }
    }

    .v-image {
        border-radius: 12px !important;
    }

    .v-card__subtitle {
        color: $blue-grey-color-300;
    }

    .v-card__title {
        @include header-h3;
        align-items: flex-start;
        transition: ease .3s;
        word-break: normal;
    }

    .v-card__text {
        @include body;
        color: $blue-grey-color-200;
    }

    .card-content {
        z-index: 30;
        position: absolute;
        bottom: -5%;
        right: 0%;
        width: 500px;
        border: 1px solid $grey-color-800;
        background: hsla(210, 11%, 15%);
        border-radius: 22px;
    }

    .card-badge-list {
        position: absolute;
        top: 4px;
        left: 8px;
        text-transform: uppercase;
        font-weight: 700;
    }

    .video-wrapper {
        video {
            height: 100vh;
            text-align: center;
        }
    }

    .video-details {
        video {
            height: auto;
        }
        .mask {
            &.black {
                background: linear-gradient(to bottom, rgba(0,0,0,70%), rgba(0,0,0,90%), rgba(0,0,0,100%) ) !important;
            }
        }
    }

    .card-section {
        position: relative;
    }

    .card-section__content {
        position: relative;
        z-index: 30;
    }
    
    .card-section__bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        bottom: -50px;
        background: url("../assets/images/glam.png");
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
    }

    .avatar-card {
        border: 1px solid $grey-color-800;
        background: hsla(210, 11%, 15%,.3);
        border-radius: 22px;
    }


@media only screen and (max-width: 600px) {
    .card {
        height: auto;

        .card-img {
            height: auto;
        }

        img {
            position: relative;
            width: 100%;
            height: auto;
        }


        .card-content {
            position: relative;
            width: auto;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue